import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'guid': 'String!'
};

export default gql(`
	query email_template( ${ HelperGraphql.createFields( fields ) } ) {
		email_template( ${ HelperGraphql.createVariables( fields ) } ) {
			guid
			type
			time
			active
			
			contents {
				subject
				content
				
				language {
					code
				}
			}
		}
	}
`);

